import React, {Component} from "react";
import { Link } from 'react-router-dom';

import AppBar from "material-ui/AppBar";
import Drawer from "material-ui/Drawer";
import MenuItem from "material-ui/MenuItem";
import PersonAdd from "material-ui/svg-icons/social/person-add";
import ContentLink from "material-ui/svg-icons/content/link";
import Divider from "material-ui/Divider";
import Download from "material-ui/svg-icons/file/file-download";
import Home from "material-ui/svg-icons/action/home";
import Image from "material-ui/svg-icons/image/image";
import CommunicationImportContacts from "material-ui/svg-icons/communication/import-contacts";
import ActionShoppingBasket from "material-ui/svg-icons/action/shopping-basket";

class MyAppBarAndMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    handleToggle = () => this.setState({open: !this.state.open});

    handleClose = () => this.setState({open: false});

    render() {
        return (
            <div>
                <AppBar
                    title="Head First Android"
                    iconClassNameRight="muidocs-icon-navigation-expand-more"
                    onLeftIconButtonTouchTap={this.handleToggle}
                    className="appbar"
                />
                <Drawer
                    docked={false}
                    width={250}
                    open={this.state.open}
                    onRequestChange={(open) => this.setState({open})}
                >
                    <img src="hfacover.jpg" width="250" alt="Book cover"/>
                    <MenuItem
                        primaryText="Overview"
                        leftIcon={<Home />}
                        containerElement={<Link to='/' />}
                        onTouchTap={this.handleClose}
                    />
                    <MenuItem
                        primaryText="Table of contents"
                        leftIcon={<CommunicationImportContacts />}
                        containerElement={<Link to='/contents' />}
                        onTouchTap={this.handleClose}
                    />
                    <MenuItem
                        primaryText="Source code"
                        leftIcon={<Download />}
                        containerElement={<Link to='/source' />}
                        onTouchTap={this.handleClose}
                    />
                    <MenuItem
                        primaryText="Images and resources"
                        leftIcon={<Image />}
                        containerElement={<Link to='/resources' />}
                        onTouchTap={this.handleClose}
                    />
                    <Divider />
                    <MenuItem
                        primaryText="Twitter"
                        leftIcon={<PersonAdd />}
                        containerElement={<Link to='/twitter' />}
                        onTouchTap={this.handleClose}
                    />
                    <MenuItem primaryText="Useful links" leftIcon={<ContentLink />} />
                    <Divider />
                    <Divider />
                    <MenuItem
                        primaryText={ <a style={{color: 'black', textDecoration: 'none'}} href='https://www.amazon.com/gp/aw/d/1491974052/'>Buy</a> }
                        leftIcon={<ActionShoppingBasket />}
                        onTouchTap={this.handleClose}
                    />
                </Drawer>
            </div>
        );
    }
}

export default MyAppBarAndMenu;



// WEBPACK FOOTER //
// ./src/components/AppBarAndMenu/AppBarAndMenu.js